import angular from 'angular';

import '../../../services/product';
import '../../../services/datastorage';


angular.module('folkeuni').component('navigationProductCategories', {
    bindings: {
        areaId: '<',
        programPageUrl: '@',
        departmentId: '<'
    },
    controller: function (DataStorage, Product, $rootScope, $timeout) {
        var $ctrl = this;
        $ctrl.currentCategories = null;


        function orderCategories(categories) {
            if (categories.length > 0) {
                var sortHelper = 0,
                    currentColumnCount = 1;

                var showAllLink = {
                    programUrl: $ctrl.programPageUrl,
                    name: "STARTER SNART"
                }

                $ctrl.currentCategories = [];
                $ctrl.currentCategories.push([showAllLink]);

                var categoryprColumnOnLarge = categories.length > 3 ? Math.ceil(categories.length / 4) : 1;

                if (categoryprColumnOnLarge == 1) {
                    //Så skal der bare være en pr column
                    for (var i = 0; categories.length > i; i++) {
                        var currentCategory = categories[i];
                        currentCategory.programUrl = $ctrl.programPageUrl + currentCategory.urlName;

                        sortHelper++;
                        if ($ctrl.currentCategories.length < sortHelper + 1) {
                            $ctrl.currentCategories.push([]);
                        }

                        $ctrl.currentCategories[sortHelper].push(currentCategory);
                    }
                }
                else {                    
                    //Hvis mere end en per column
                    for (var i = 0; categories.length > i; i++) {
                        var currentCategory = categories[i];
                        currentCategory.programUrl = $ctrl.programPageUrl + currentCategory.urlName;

                        if (!$ctrl.currentCategories) {
                            $ctrl.currentCategories = [];
                        }

                        if ($ctrl.currentCategories.length < sortHelper + 1) {
                            $ctrl.currentCategories.push([]);
                        }

                        $ctrl.currentCategories[sortHelper].push(currentCategory);


                        currentColumnCount++;
                        if (currentColumnCount == categoryprColumnOnLarge) {
                            sortHelper++;
                            currentColumnCount = 0;
                        }

                    }
                }
            }
        }

        function fetchCategories(keyAccountOnly) {
            var areaObj = {
                siteId: $ctrl.departmentId,
                areaId: $ctrl.areaId ? $ctrl.areaId : null,
                keyAccountOnly: keyAccountOnly
            }
            
            if (areaObj.areaId != null) {
                Product.getProductCategoriesByArea(areaObj).then(function (categories) {                      
                    orderCategories(categories);
                }, function (err) {
                    
                });
            } else {
                Product.getCategories($ctrl.departmentId, keyAccountOnly).then(function (categories) {
                    orderCategories(categories);
                }, function (err) {
                });
            }
        }

        $rootScope.$on('updateKeyAccount', function (event, data) {
         
            fetchCategories(data.keyAccountOnly);
            
        });

        $ctrl.$onInit = function () {
          
            if (window.location.href.indexOf('voucher=1') == -1) {
                DataStorage.get("programfilter").then(function (data) {
                    fetchCategories(JSON.parse(data).keyAccountOnly);
                }, function () { });
            }
        }

        $ctrl.setCategory = function(programUrl) {
            DataStorage.set('lastUsedDepartmentProgram', programUrl);
        }

    },
    templateUrl: '/shop-dist/templates/product-categories.html?c=' + window.cacheBurst,
    transclude: true
});